import script from "./CalendarioPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarioPage.vue?vue&type=script&setup=true&lang=js"

import "./CalendarioPage.vue?vue&type=style&index=0&id=5e958bb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e958bb6"]])

export default __exports__